export default __webpack_public_path__ + "static/silverMtag-93b87b0b1b72908ad4a8e3b4e21b05c0.png";